export default {
    TEMPLATES ({ templates }) {
      return templates
    },
    TEMPLATES_SEARCHQUERY ({ templatesSearchquery }) {
      return templatesSearchquery
    }
  }
